import React from 'react';

import FeedEvent from './FeedEvent';

type Props = {
  children: React.ReactNode;
};

function Feed({ children }: Props) {
  return (
    <div className="feed flow-root">
      <ul>{children}</ul>
    </div>
  );
}

export default Object.assign(Feed, { Event: FeedEvent });
